<app-table [params]="tableParams" (actioned)="emit($event)"></app-table>

